import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Désactive le Navigator LockManager cross-tab : il peut deadlock et bloquer
// supabase.auth.getSession() indéfiniment (page admin blanche).
// La sync cross-tab reste assurée par les events storage + onAuthStateChange.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    lock: (_name, _acquireTimeout, fn) => fn(),
  },
})
